export const userData = {
  account: 'test',
  name: 'Test',
  email: 'test@gmail.com',
  avatar: 'https://i.imgur.com/ZyXrPxB.png',
  cover: 'https://i.imgur.com/jXE6Mmp.png',
  introduction:
    'Quod quod aut qui. Quo ut nisi voluptatum sit ea. Ea nihil nisi totam officia non minus. Accusantium id voluptatum officia voluptatem aliquid autem dolorum unde',
}
